// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  width: 100%;
  height: 100%;
}

.header_block {
  width: 100%;
  padding: 10px 15px 0px;
  background: white;
  display: flex;
  justify-content: space-between;
  box-shadow: 0px -4px 50px 0px rgba(0, 0, 0, 0.1019607843);
}
.header_block .wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.header_block .wrapper .back_icon {
  width: 20%;
  text-align: start;
}
.header_block .wrapper app-burger-btn {
  width: 20%;
}
.header_block ion-icon {
  width: 20px;
}
.header_block h5 {
  font-size: 18px;
  color: black;
  font-family: AppFontBold, sans-serif;
}

.block_item {
  width: 100%;
  height: calc(100% - 150px);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: url('background_wood.png') no-repeat center center/100% 100%;
  position: relative;
}
.block_item .left {
  width: 49.9%;
  height: 100%;
}
.block_item .left .article_info {
  left: 0px !important;
}
.block_item .right {
  width: 49.9%;
  height: 100%;
}
.block_item .right swiper-slide {
  justify-content: flex-start !important;
}
.block_item .right .slide__card {
  justify-content: flex-start !important;
}
.block_item .right .article_info {
  right: 0px !important;
  text-align: right !important;
}
.block_item .random_slide {
  position: absolute;
  bottom: 40px;
  right: 20px;
  z-index: 5;
  text-align: center;
  width: 60px;
}
.block_item .random_slide p {
  color: white;
  font-family: AppFontBold, Helvetica, sans-serif;
  font-size: 12px;
  background: transparent;
  text-transform: uppercase;
  text-align: center;
  padding: 5px;
}
.block_item .random_slide ion-icon {
  width: 45px;
  height: 45px;
}
.block_item .total_price_section {
  font-family: AppFontBold;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  text-transform: uppercase;
}

.swiper_block {
  width: 100%;
  height: 100%;
}

.slide.swiper-slide-active .slide__card {
  height: 105%;
  opacity: 1;
  position: relative;
}
.slide.swiper-slide-active .slide__card img {
  height: 100%;
  width: auto;
}
@media (min-width: 991px) {
  .slide.swiper-slide-active .slide__card img {
    height: 110%;
    object-fit: fill;
    width: auto;
  }
}
.slide.swiper-slide-active .slide__card ion-img {
  height: 100%;
  width: 50%;
}
@media (min-width: 991px) {
  .slide.swiper-slide-active .slide__card ion-img {
    height: 110%;
    object-fit: fill;
    width: auto;
  }
}
.slide.swiper-slide-active .slide__card .article_info {
  position: absolute;
  top: -40px;
  display: block;
  text-align: left;
}
.slide.swiper-slide-active .slide__card .article_info h4 {
  color: white;
}
.slide__card {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 60%;
  opacity: 0.5;
  transition: opacity 1s;
  width: 80%;
  position: relative;
}
.slide__card ion-img {
  height: 80%;
  width: 45%;
}
.slide__card img {
  height: 80%;
  width: auto;
}
.slide__card .article_info {
  position: absolute;
  top: 0px;
  display: none;
}

swiper-container {
  width: 100% !important;
  height: 100% !important;
  margin: 0 auto !important;
  --swiper-pagination-left: 20px;
  --swiper-pagination-bullet-width: 2px;
  --swiper-pagination-bullet-size: 12px;
  --swiper-pagination-bullet-border-radius: 0px;
  --swiper-pagination-bullet-inactive-color: rgb(168, 168, 168);
  --swiper-pagination-color: white;
  --swiper-pagination-bullet-vertical-gap: 0px;
}
swiper-container swiper-slide {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.right {
  --swiper-pagination-right: 20px;
  --swiper-pagination-left: 20;
  --swiper-pagination-bullet-width: 2px;
  --swiper-pagination-bullet-size: 12px;
  --swiper-pagination-bullet-border-radius: 0px;
  --swiper-pagination-bullet-inactive-color: rgb(168, 168, 168);
  --swiper-pagination-color: white;
  --swiper-pagination-bullet-vertical-gap: 0px;
}
.right swiper-slide {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.footer_block {
  width: 100%;
  display: flex;
  background: var(--default-background);
  justify-content: center;
  box-shadow: 0px -4px 50px 0px rgba(0, 0, 0, 0.1019607843);
  padding: 20px 0px 0px 0px;
  z-index: 99;
}
.footer_block ion-button {
  width: 95%;
}

.step_block {
  position: absolute;
  top: 20px;
  left: 20px;
  border: 2px dashed white;
  padding: 5px;
}
.step_block h5 {
  font-size: 14px;
  color: white;
}

.plate {
  position: absolute;
  width: 0px;
  aspect-ratio: 1/1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  overflow: auto;
}
.plate ion-img {
  height: 100%;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/select-half-pizza/select-half-pizza.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAGA;EACI,WAAA;EACA,YAAA;AAFJ;;AAIA;EACI,WAAA;EACA,sBAAA;EAEA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,yDAAA;AAFJ;AAGI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AADR;AAEQ;EACI,UAAA;EACA,iBAAA;AAAZ;AAEQ;EACI,UAAA;AAAZ;AAII;EACI,WAAA;AAFR;AAKI;EACI,eAAA;EACA,YAAA;EACA,oCAAA;AAHR;;AAOA;EACI,WAAA;EACA,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,wEAAA;EACA,kBAAA;AAJJ;AAMI;EACI,YAAA;EACA,YAAA;AAJR;AAKQ;EACI,oBAAA;AAHZ;AAUI;EACI,YAAA;EACA,YAAA;AARR;AASQ;EACI,sCAAA;AAPZ;AASQ;EACQ,sCAAA;AAPhB;AAUQ;EACI,qBAAA;EACA,4BAAA;AARZ;AAWI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;AATR;AAUQ;EACI,YAAA;EACA,+CAAA;EACA,eAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AARZ;AAUQ;EACI,WAAA;EACA,YAAA;AARZ;AAWI;EACI,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,yBAAA;AATR;;AAYA;EACI,WAAA;EACA,YAAA;AATJ;;AAcQ;EACI,YAAA;EACA,UAAA;EACA,kBAAA;AAXZ;AAYY;EACI,YAAA;EACA,WAAA;AAVhB;AC5GE;EDoHU;IAIQ,YAAA;IACA,gBAAA;IACA,WAAA;EARlB;AACF;AAUY;EACI,YAAA;EACA,UAAA;AARhB;ACvHE;ED6HU;IAIQ,YAAA;IACA,gBAAA;IACA,WAAA;EANlB;AACF;AAUY;EACI,kBAAA;EAEA,UAAA;EACA,cAAA;EACA,gBAAA;AAThB;AAUgB;EACI,YAAA;AARpB;AAcI;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EASA,kBAAA;AApBR;AAYQ;EACI,WAAA;EACA,UAAA;AAVZ;AAYQ;EACI,WAAA;EACA,WAAA;AAVZ;AAcQ;EACI,kBAAA;EAEA,QAAA;EACA,aAAA;AAbZ;;AAkBE;EACE,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,8BAAA;EACA,qCAAA;EACA,qCAAA;EACA,6CAAA;EACA,6DAAA;EACA,gCAAA;EACA,4CAAA;AAfJ;AAgBI;EACE,eAAA;EACA,aAAA;EAEA,mBAAA;EACA,yBAAA;AAfN;;AAqBA;EAKI,+BAAA;EACA,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,6CAAA;EACA,6DAAA;EACA,gCAAA;EACA,4CAAA;AAtBJ;AAuBI;EACE,eAAA;EACA,aAAA;EAEA,mBAAA;EACA,yBAAA;AAtBN;;AA4BA;EACI,WAAA;EACA,aAAA;EACA,qCAAA;EAEA,uBAAA;EACA,yDAAA;EACA,yBAAA;EACA,WAAA;AA1BJ;AA2BI;EACI,UAAA;AAzBR;;AA4BA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;EACA,YAAA;AAzBJ;AA0BI;EACI,eAAA;EACA,YAAA;AAxBR;;AA4BA;EACC,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,cAAA;AAzBD;AA0BC;EACG,YAAA;EACA,WAAA;AAxBJ","sourcesContent":["\n@import '../../../theme/mixins';\n\n.main {\n    width: 100%;\n    height: 100%;\n}\n.header_block {\n    width: 100%;\n    padding: 10px 15px 0px;\n\n    background:white;\n    display: flex;\n    justify-content: space-between;\n    box-shadow: 0px -4px 50px 0px #0000001A;\n    .wrapper {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        width: 100%;\n        .back_icon {\n            width: 20%;\n            text-align: start;\n        }\n        app-burger-btn {\n            width: 20%;\n        }\n    }\n\n    ion-icon {\n        width: 20px;\n\n    }\n    h5 {\n        font-size: 18px;\n        color: black;\n        font-family: AppFontBold, sans-serif;\n    }\n}\n\n.block_item {\n    width: 100%;\n    height: calc(100% - 150px);\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    background: url('../../../assets/losteria/background_wood.png') no-repeat center center/ 100% 100%;\n    position: relative;\n   \n    .left {\n        width: 49.9%;\n        height: 100%;\n        .article_info {\n            left: 0px !important;\n            \n        }\n        .first {\n            // rotate: 180deg;\n        }\n    }\n    .right {\n        width: 49.9%;\n        height: 100%;\n        swiper-slide {\n            justify-content: flex-start !important;\n        }\n        .slide__card {\n                justify-content: flex-start !important;\n               \n        }\n        .article_info {\n            right: 0px !important;\n            text-align: right !important;\n        }\n    }\n    .random_slide {\n        position: absolute;\n        bottom: 40px;\n        right: 20px;\n        z-index: 5;\n        text-align: center;\n        width: 60px;\n        p {\n            color: white;\n            font-family: AppFontBold, Helvetica, sans-serif;\n            font-size: 12px;\n            background: transparent;\n            text-transform: uppercase;\n            text-align: center;\n            padding: 5px;\n        }\n        ion-icon {\n            width: 45px;\n            height: 45px;\n        }\n    }\n    .total_price_section {\n        font-family: AppFontBold;\n        position: absolute;\n        bottom: 20px;\n        left: 50%;\n        transform: translateX(-50%);\n        color: white;\n        text-transform: uppercase;\n    }\n}\n.swiper_block {\n    width: 100%;\n    height: 100%;\n}\n\n  .slide {\n    &.swiper-slide-active {\n        .slide__card {\n            height: 105%;\n            opacity: 1;\n            position: relative;\n            img {\n                height: 100%;\n                width: auto;\n                @include desktop {\n                    height: 110%;\n                    object-fit: fill;\n                    width: auto;\n                }\n            }\n            ion-img {\n                height: 100%;\n                width: 50%;\n                @include desktop {\n                    height: 110%;\n                    object-fit: fill;\n                    width: auto;\n                }\n\n            }\n         \n            .article_info {\n                position: absolute;\n                // left: 0px;\n                top: -40px;\n                display: block;\n                text-align: left;\n                h4 {\n                    color: white;\n\n                }\n            }\n        }\n    }\n    &__card {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        height: 60%;\n        opacity: 0.5;\n        transition: opacity 1s;\n        width: 80%;\n        ion-img {\n            height: 80%;\n            width: 45%;\n        }\n        img {\n            height: 80%;\n            width: auto;\n        }\n        position: relative;\n       \n        .article_info {\n            position: absolute;\n            // left: 0px;\n            top: 0px;\n            display: none;\n        }\n \n    }\n}\n  swiper-container{\n    width: 100% !important;\n    height: 100% !important;\n    margin: 0 auto !important;\n    --swiper-pagination-left: 20px;\n    --swiper-pagination-bullet-width: 2px;\n    --swiper-pagination-bullet-size: 12px;\n    --swiper-pagination-bullet-border-radius: 0px;\n    --swiper-pagination-bullet-inactive-color: rgb(168, 168, 168);\n    --swiper-pagination-color: white;\n    --swiper-pagination-bullet-vertical-gap: 0px;\n    swiper-slide {\n      max-width: 100%;\n      display: flex;\n\n      align-items: center;\n      justify-content: flex-end;\n    } \n  }\n//  swiper-container::part(pagination) {\n//     rotate: 90deg;\n// }\n.right {\n    // width: 100% !important;\n    // height: 100% !important;\n    // margin: 0 auto !important;\n    // --swiper-pagination-left: 100%;\n    --swiper-pagination-right: 20px;\n    --swiper-pagination-left: 20;\n    --swiper-pagination-bullet-width: 2px;\n    --swiper-pagination-bullet-size: 12px;\n    --swiper-pagination-bullet-border-radius: 0px;\n    --swiper-pagination-bullet-inactive-color: rgb(168, 168, 168);\n    --swiper-pagination-color: white;\n    --swiper-pagination-bullet-vertical-gap: 0px;\n    swiper-slide {\n      max-width: 100%;\n      display: flex;\n\n      align-items: center;\n      justify-content: flex-end;\n    } \n}\n\n \n  \n.footer_block {\n    width: 100%;\n    display: flex;\n    background: var(--default-background);\n\n    justify-content: center;\n    box-shadow: 0px -4px 50px 0px #0000001A;\n    padding: 20px 0px 0px 0px;\n    z-index: 99;\n    ion-button {\n        width: 95%;\n    }\n}\n.step_block {\n    position: absolute;\n    top: 20px;\n    left: 20px;\n    border: 2px dashed white;\n    padding: 5px;\n    h5 {\n        font-size: 14px;\n        color: white;\n    }\n}\n\n.plate {\n position: absolute;\n width: 0px;\n aspect-ratio: 1 / 1;\n top: 50%;\n left: 50%;\n transform: translate(-50%, -50%);\n z-index: 1;\n overflow: auto;\n ion-img {\n    height: 100%;\n    width: 100%;\n }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
